import {
  EntityBarFilterConfig,
  IconBarsThree,
  IconPlay
} from '@sequencehq/core-components'
import {
  NOTIFICATIONS_FILTER_VALUE,
  WatchtowerFilterType
} from 'Automations/watchtower/atoms'

export const ALL_TASKS_FILTER_CONFIGS: ({
  useAutomationsDunning
}: {
  useAutomationsDunning: boolean
}) => EntityBarFilterConfig<WatchtowerFilterType>[] = ({
  useAutomationsDunning
}) => {
  return [
    {
      type: 'status',
      label: 'Status',
      icon: IconBarsThree,
      options: [
        { label: 'Pending', value: 'PENDING' },
        { label: 'Completed', value: 'COMPLETED' },
        { label: 'Cancelled', value: 'CANCELLED' }
      ]
    },
    {
      type: 'trigger',
      label: 'Type',
      icon: IconPlay,
      options: [
        { label: 'Quotes', value: 'QUOTE_REQUIRES_APPROVAL' },
        { label: 'Contract intake', value: 'CONTRACT_UPLOADED' },
        ...(useAutomationsDunning
          ? [{ label: 'Invoice reminders', value: 'INVOICE_SENT' }]
          : []),
        { label: 'System notifications', value: NOTIFICATIONS_FILTER_VALUE }
      ]
    }
  ]
}
